export default "__VITE_ASSET__518bb1a2__"